// extracted by mini-css-extract-plugin
export default {"fullPage":"LoadingPage_fullPage__sQ4-K"};